import React, { LegacyRef } from 'react';
import { useSelector } from 'react-redux';
import { twMerge } from 'tailwind-merge';

import { DownloadBottom as DownloadIcon } from '@videoblocks/react-icons';

import { StockItem } from '../../../common/types/StockItemTypes';
import { selectDetailsStockItem } from '../../selectors/detailsSelectors';

type Props = {
  previewHandler?: () => void;
  iconOnLeft?: boolean;
  previewText?: string;
  referenceElement?: LegacyRef<HTMLButtonElement>;
};

const PreviewButton = ({
  previewHandler = () => undefined,
  iconOnLeft = true,
  previewText = 'PREVIEW',
  referenceElement,
}: Props) => {
  const stockItem = useSelector(selectDetailsStockItem);

  const getAriaLabel = (stockItem: StockItem) => {
    const contentClass = stockItem?.contentClass;
    const title = stockItem?.title;
    const labelType = contentClass === 'video' ? 'Watermarked' : 'preview';
    return `Download ${labelType} - ${title}`;
  };

  return (
    <button
      className={twMerge(
        'previewButton float-right md:float-none flex-nowrap relative flex bg-transparent border-0 rounded',
        iconOnLeft && 'p-1 text-xs bg-gray-100'
      )}
      onClick={previewHandler}
      aria-label={getAriaLabel(stockItem)}
      ref={referenceElement ? referenceElement : null}
    >
      {iconOnLeft && (
        <img
          alt="download preview icon"
          className="h-4 left-icon"
          src={__ASSETS_COMMON_IMAGES_URL__ + '/icons/preview.svg'}
          width={16}
          height={16}
        />
      )}
      <span className="mr-2">{previewText}</span>
      {!iconOnLeft && (
        <DownloadIcon className="action-icon align-middle fill-current h-4 w-4" />
      )}
    </button>
  );
};

export default PreviewButton;
